import {
  Box,
  Button,
  Card,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import mime from "mime";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import { saveAs } from "file-saver";
export default function Detail_EIR() {
  const { id } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    const getDetail = async () => {
      const res = await api.get(`api/eir/detail/${id}`);
      const data = await res.data;
      setData(data);
    };
    getDetail();
  }, [id]);
  return (
    <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
      <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
        EIR
      </h6>

      <Grid
        container
        alignItems="center"
        spacing={1}
        sx={{ justifyContent: "space-between" }}
      >
        <Grid item>
          <Typography className="textcolordarkblue" variant="h5" component="h1">
            Equipment Interchange Receipt
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex", flexDirection: "row" }}>
          <Typography className="textcolorBule">Truck </Typography>
          <Typography>
            <span>&nbsp;</span> / AddEIR
          </Typography>
        </Grid>
      </Grid>

      <Grid
        style={{
          marginTop: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            width: "100%",
            marginTop: "10px",
            paddingBottom: "24px",
          }}
        >
          <Grid container>
            <Grid xs={4} sx={{ marginRight: "15px" }}>
              <FormControl
                sx={{
                  width: "100%",
                  marginRight: "10px",
                }}
              >
                <InputLabel>EIR Type</InputLabel>
                <Select
                  label="EIR Type"
                  value={data?.EIRType ? data?.EIRType : ""}
                  // InputLabelProps={{ shrink: true }}

                  // disabled={values.liners !== ""}
                >
                  <MenuItem value={"ToFactory"}>ToFactory</MenuItem>
                  <MenuItem value={"FromFactory"}>FromFactory</MenuItem>
                  <MenuItem value={"Other"}>Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={4} sx={{ marginRight: "15px" }}></Grid>

            <Grid xs={4} sx={{ marginRight: "15px" }}>
              <TextField
                disabled
                label="SaleOrderNo."
                value={data?.SaleOrderNo}
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={4} sx={{ marginRight: "15px" }}>
              <TextField
                disabled
                label="BookingNo."
                value={data?.BookingNo}
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={4} sx={{ marginRight: "15px" }}>
              <TextField
                disabled
                label="Customer Name"
                value={data?.CustomerName}
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={4} sx={{ marginRight: "15px" }}>
              <TextField
                label="Factory Name."
                value={data?.FactoryName}
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  // backgroundColor: "#EAECEF",
                }}
                disabled
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={4} sx={{ marginRight: "15px" }}>
              <TextField
                disabled
                label="Factory Address"
                value={data?.FactoryAddress}
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  // backgroundColor: "#EAECEF",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={4} sx={{ marginRight: "15px" }}>
              <TextField
                disabled
                label="Tel."
                value={data?.FactoryTel}
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  // backgroundColor: "#EAECEF",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={4} sx={{ marginRight: "10px" }}>
              <TextField
                disabled
                label="Date"
                value={moment(data?.EIRDate).format("DD/MM/yyyy")}
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  // backgroundColor: "#EAECEF",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={4}>
              <TextField
                disabled
                label="Time"
                value={data?.EIRTime}
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  // backgroundColor: "#EAECEF",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={4} sx={{ marginRight: "10px" }}>
              <TextField
                disabled
                label="TruckCompany"
                value={data?.TruckCompany}
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  // backgroundColor: "#EAECEF",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={4}>
              <TextField
                disabled
                label="TruckNo"
                value={data?.TruckNo}
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  // backgroundColor: "#EAECEF",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>

          <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
            <Table stickyHeader>
              <TableRow>
                <TableCell align="center" width="15%">
                  Container No.
                </TableCell>
                <TableCell align="center" width="15%">
                  SealCarrier{" "}
                </TableCell>
                {/* <TableCell align="center" width="15%">Seal 1</TableCell>
                                <TableCell align="center" width="15%">Seal 2</TableCell>
                                <TableCell align="center" width="10%">TareWeight</TableCell>
                                <TableCell align="center" width="10%">CargoWeight</TableCell> */}
                <TableCell align="center" width="10%">
                  Weight
                </TableCell>
                {/* <TableCell align="center" width="10%">STATUS</TableCell> */}
              </TableRow>
              {data?.Detail?.map((data, index) => {
                return (
                  <TableRow>
                    <TableCell>{data?.ContainerNo}</TableCell>
                    <TableCell>{data?.SealCarrierNo}</TableCell>
                    {/* <TableCell>{data?.Seal_1}</TableCell>
                                        <TableCell>{data?.Seal_2}</TableCell> */}
                    {/* <TableCell>{data?.TareWeight}</TableCell>
                                        <TableCell>{data?.CargoWeight}</TableCell> */}
                    <TableCell>{data?.Weight}</TableCell>
                    {/* <TableCell>{data?.ContainerStatus}</TableCell> */}
                  </TableRow>
                );
              })}
            </Table>
          </TableContainer>
          <Box sx={{ display: "flex", marginTop: "100px" }}>
            <Box sx={{ display: "flex" }}>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                variant="outlined"
                style={{
                  background: "#fff",
                  borderColor: "#C8C8C8",
                  marginRight:'10px'
                }}
                onClick={async () => {
                  setLoading(true);
                  await api
                    .get(
                      `api/report/EIR/download/pdf?EIRId=${id}`,
                      {
                        responseType: "blob",
                        timeout: 10000,
                      }
                    )
                    .then((blobFile) => {
                      const blobFileRes = new File(
                        [blobFile?.data],
                        "test.pdf",
                        {
                          type: mime.getType(".pdf"),
                        }
                      );

                      // window.open(
                      //   URL.createObjectURL(blobFileRes, "test.csv"),
                      //   "_blank"
                      // );
                      saveAs(blobFileRes, "ReportEIR.pdf");
                      setLoading(false);
                    });
                }}
              >
                {loading ? (
                  <CircularProgress size={22} />
                ) : (
                  <Typography sx={{ color: "#8E8C8C" }}>Print</Typography>
                )}
              </Button>
              <Button
                // type="submit"
                variant="outlined"
                style={{
                  color: "rgb(245, 60, 86)",
                  borderColor: "rgb(245, 60, 86)",
                  marginRight: "10px",
                }}
                onClick={() => {
                  const body = {
                    EIRId: data?.EIRId,
                    Status: false,
                  };
                  const updateStuts = async () => {
                    const res = await api.post(`api/eir/update`, body);
                    if (res.meta.status) {
                      Swal.fire({
                        title: `${res.meta.message}`,
                        icon: "success",
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "OK",
                        allowOutsideClick: false,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          console.log("first");
                        }
                      });
                    }
                  };
                  Swal.fire({
                    title: "Are you sure?",
                    // text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, Cencel it!",
                    cancelButtonText: "close",
                    allowOutsideClick: false,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      updateStuts();
                    }
                  });
                }}
              >
                Cencel
              </Button>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Card>
  );
}
